import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import { AnswersContext } from "../../store/AnswersContext/AnswersContext";

export default function BaseLayout({ children }) {
  const { answerData } = useContext(AnswersContext);
  const location = useLocation();
  const navigate = useNavigate();

  // Check if data is missing and we're not already on "/"
  useEffect(() => {
    const isEmpty = !Array.isArray(answerData) || answerData.length === 0;
    if (isEmpty && location.pathname !== "/") {
      navigate("/", { replace: true });
    }
  }, [answerData, location.pathname, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 pb-8">
      <Header />
      <main className="px-8">{children}</main>
    </div>
  );
}
